module.exports = __webpack_public_path__ + "3.714cc79740b06c00c88d.jpg";


//////////////////
// WEBPACK FOOTER
// C:/Users/Home/OneDrive/Documents/hotellife_web/src/assets/images/bg/3.jpg
// module id = ../../../../../src/assets/images/bg/3.jpg
// module chunks = styles